<template>
  <div>
    <ul :class="$style.list">
      <li v-for="node in nodes" :key="node.guid" :class="$style.list__item">
        <BookingListElement :booking="node" />
      </li>
    </ul>
    <FlatButton
      v-if="hasLoadMore"
      :class="$style.loadMoreButton"
      variant="secondary"
      @click="onClickLoadMore"
      :disabled="isLoadingMore"
    >
      もっと見る
    </FlatButton>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import FlatButton from '@/components/atoms/FlatButton.vue'
import BookingListElement from './BookingListElement.vue'
import type { BookingListBookingConnectionFragment } from './BookingList.generated.ts'

const props = defineProps<{
  bookingConnection: BookingListBookingConnectionFragment
  isLoading?: boolean
}>()

const emits = defineEmits<{
  (e: 'clickLoadMore', after: string | null): Promise<void>
}>()

const nodes = computed(() => props.bookingConnection.edges.map(e => e.node))
const hasLoadMore = computed(() => props.bookingConnection.pageInfo.hasNextPage)
const isLoadingMore = ref(false)

const onClickLoadMore = async () => {
  if (hasLoadMore.value) {
    emits('clickLoadMore', props.bookingConnection.pageInfo.endCursor ?? null)
  }
}
</script>

<style lang="scss" module>
.list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
}

.loadMoreButton {
  margin-top: 16px;
}
</style>
